const PDF_EXTENSIONS = [".pdf"];

const GENERIC_EXTENSIONS = [
  ".txt",
  ".md",
  ".html",
  ".docx",
  ".ppt",
  ".pptx",
  ".csv",
  ".xlsx",
  ".xlsm",
  ".java",
  ".py",
  ".yaml",
  ".yml",
  ".xml",
  ".sql",
  ".sh",
  ".php",
  ".js",
  ".ts",
  ".tsx",
  ".jsx",
  ".csharp",
  ".rb",
];

const ARTIFACT_EXTENSIONS = [
  ".png",
  ".jpg",
  ".jpeg",
  ".gif",
  ".webp",
  ".svg",
  ".avif",
  ".mp3",
  ".m4a",
  ".aac",
  ".flac",
  ".ogg",
  ".mp4",
  ".webm",
  ".mov",
];

const getFileExtension = (fileOrName) => {
  const name = typeof fileOrName === "string" ? fileOrName : fileOrName?.name;
  if (!name || !name.includes(".")) return "";
  return "." + String(name.split(".").pop()).toLowerCase();
};

const categorizeFiles = (files) => {
  const pdfFiles = [];
  const genericFiles = [];
  const artifactFiles = [];

  Array.from(files || []).forEach((file) => {
    const ext = getFileExtension(file);
    if (PDF_EXTENSIONS.includes(ext)) {
      pdfFiles.push(file);
    } else if (ARTIFACT_EXTENSIONS.includes(ext)) {
      artifactFiles.push(file);
    } else if (GENERIC_EXTENSIONS.includes(ext)) {
      genericFiles.push(file);
    }
  });

  return { pdfFiles, genericFiles, artifactFiles };
};

const isArtifactExtension = (ext) =>
  ARTIFACT_EXTENSIONS.includes(
    ext?.startsWith(".") ? ext.toLowerCase() : `.${ext?.toLowerCase()}`,
  );

export {
  PDF_EXTENSIONS,
  GENERIC_EXTENSIONS,
  ARTIFACT_EXTENSIONS,
  categorizeFiles,
  getFileExtension,
  isArtifactExtension,
};

export default {
  PDF_EXTENSIONS,
  GENERIC_EXTENSIONS,
  ARTIFACT_EXTENSIONS,
  categorizeFiles,
  getFileExtension,
  isArtifactExtension,
};